<template>
  <div id="app">
    <Loader v-if="!isLoaded" :fit20="this._data" />
    <Header v-if="!adminApp && !logOut" :fit20="this._data" :selectTab="selectTab"
      :clearLocalStorage="clearLocalStorage"></Header>
    <Error v-if="errMsgs.length > 0" :fit20="this._data" :closeError="closeError"></Error>
    <Alert v-if="alerts.length > 0" :fit20="this._data" :closeAlert="closeAlert"></Alert>
    <Main v-if="!adminApp && !logOut" :selectTab="selectTab" :fit20="this._data" :formatDate="formatDate"
      :clearLocalStorage="clearLocalStorage"></Main>
    <Admin v-if="adminApp && !logOut" :selectTab="selectTab" :fit20="this._data" :formatDate="formatDate"></Admin>
    <Home v-if="logOut" :fit20="this._data"></Home>
  </div>
</template>

<script>
import Loader from './components/Loader';
import Home from './components/Home';
import Error from './components/Error.vue';
import Alert from './components/Alert.vue'
import Header from './components/Header';
import Main from './components/Main';
import Admin from './components/admin/Admin';
import { formattedDateTime } from "./actions/global"
// import i18n from './internationalization/i18n';

export default {
  name: 'app',
  components: {
    Admin,
    Loader,
    Header,
    Main,
    Error,
    Alert,
    Home
  },
  data() {
    return {
      logOut: false,
      messages: {},
      defaultMemberImg: "",
      defaultStudioImg: "",
      errMsgs: [],
      alerts: [],
      absentReasons: [],
      sensorsMachines: [],
      machineWithSensor: ['1001', '1002', '2002', '3001', '4001', '4002', '5001'],
      activeTab: 'tab_id0',
      test555: "",
      hostProtocol: window.location.protocol + "//",
      MSA_port: '1064',
      baseUrl: window.location.host.includes("localhost") ? "http://localhost:8888" : window.location.host.includes('192.168.1') ? "http://192.168.1.172:8888" : "",
      storageBaseUrl: window.location.host.includes("localhost") || window.location.host.includes('192.168.1') || window.location.host.includes('test.') ? window.location.protocol + "//storage.googleapis.com/fit20app-4-acctest.appspot.com" : "https://storage.googleapis.com/fit20app",
      newLegPress: window.location.host.includes("localhost") || window.location.host.includes('192.168.1') || window.location.host.includes('test.') ? "5566215545159680" : "6060688494034944",
      isLoaded: false,
      adminApp: false,
      errors: [],
      logs: [],
      currentMembers: [
        [],
        [],
        []
      ],
      selectedTabHref: "#studios",
      selectTabId: 'tab_id0',
      studios: [],
      studio: {},
      user: {},
      studioMachines: [],
      machines: [],
      languages: [],
      brands: [],
      motivationMsg: [],
      tabs: {
        tab2: {
          active: false,
          action: '',
          exercisesControl: [],
        },
        tab3: {
          active: false,
          action: '',
          exercisesControl: [],
        },
        tab4: {
          active: false,
          action: '',
          exercisesControl: [],
        },
      },
      exercisesControl: {
        tab2: [],
        tab3: [],
        tab4: [],
      },
      saveSessionControl: {
        tab2: [],
        tab3: [],
        tab4: [],
      },
      durationTable: [],
      qsTable: [],
      weightedTable: {},
      trainingAgeTable: {
        male: {},
        female: {},
      },
      sessionsUsed: 4,
      maxIncrease: 5,
      maxDecrease: 5,
      minAgeExercise: 20,
      minSessionsNeeded: 8,
      QSType: '',
    };
  },
  methods: {
    getBrowserInfo() {
      const userAgent = navigator.userAgent;

      if (userAgent.includes("Firefox")) {
        return "Firefox";
      } else if (userAgent.includes("Edg")) {
        return "Microsoft Edge";
      } else if (userAgent.includes("Chrome")) {
        return "Chrome";
      } else if (userAgent.includes("Safari")) {
        return "Safari";
      } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
        return "Opera";
      } else {
        return "Unknown Browser";
      }
    },
    clearLocalStorage() {
      window.onfocus = null;
      window.onload = null;
      window.onclick = null;
      // window.onkeypress = null;
      window.ontouchstart = null;
      window.onmousemove = null;
      window.onmousedown = null;
      window.ontouchstart = null;
      window.ontouchmove = null;
      window.ontouchend = null;
      // window.removeEventListener('scroll', resetTime, true);
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('last_token_time');
      localStorage.removeItem('user-email');
      localStorage.removeItem('check_time');
    },
    async getTranslation() {
      try {
        let data;
        // let basedUrl = this.baseUrl.includes('localhost') ? 'http://localhost:8888' : this.baseUrl;
        // const response = await fetch(basedUrl + '/api/translations');
        let bucketName =
          this.baseUrl.includes('test.') || this.baseUrl.includes('localhost')
            ? 'fit20app-4-acctest.appspot.com'
            : 'fit20app';

        const response = await fetch('https://storage.googleapis.com/' + bucketName + '/static/assets/internationalization.tsv');
        if (response.ok) {
          data = await response.text();
        } else {
          window.alert(this.$t('get-translation-err'));
          // throw new Error('Failed to fetch translation files');
        }
        const messages = {};
        // Parse the TSV data and populate the messages object
        const lines = data.split('\n');
        // Assuming the first line contains the languages/codes
        const languages = lines[0].split('\t').slice(1);

        languages.forEach((lang, index) => {
          messages[lang] = {};
          lines.slice(1).forEach((line) => {
            const columns = line.split('\t');
            const code = columns[0];
            messages[lang][code] = columns[index + 1].replace('\r', '');
          });

          this.languages.push({
            code: lang,
            name: messages[lang]['L0000'],
          });
        });
        this.messages = messages;
        let langCode = this.user.language && this.user.language.length > 0 ? this.user.language : 'en';
        this.$i18n.setLocaleMessage(langCode, this.messages[langCode]);
        this.$i18n.locale = langCode;
        this.brands = Object.keys(messages['en']).filter((item) => item.includes('brand-'));
        this.motivationMsg = Object.keys(messages['en']).filter((item) => item.includes('M80'));
        Object.keys(this.messages[langCode]).filter((item) => item.includes('absent-reasons-')).forEach(reason => {
          this.absentReasons.push(reason);
        });

      } catch (err) {
        console.log(err);
      }
    },
    async getRefreshToken() {
      try {
        // localStorage.setItem('user-email', "test");
        let refreshToken = localStorage.getItem('refresh_token');
        if (refreshToken) {
          const url =
            this.baseUrl + '/api/auth/accessToken?refresh_token=' + refreshToken + `&baseURL=${this.baseUrl.replace(/^https?:\/\//, '')}`;
          const result = await fetch(url);
          const results = await result.json();
          if (results.msg) {
            this.clearLocalStorage();
            this.isLoaded = true;
            window.alert(this.$t('authentication-error'));
          } else {
            const base64Url = results.id_token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            const decodedToken = JSON.parse(jsonPayload);
            localStorage.setItem('access_token', results.access_token);
            localStorage.setItem('last_token_time', new Date().getTime());
            this.errors.push('get refresh token app.js ' + formattedDateTime());

          }
        } else {
          this.signOut();
        }
      } catch (err) {
        this.clearLocalStorage();
        this.isLoaded = true;
        window.alert(this.$t('authentication-error'));
      }
    },
    signOut() {
      this.isLoaded = false;
      this.clearLocalStorage();
      const img = document.createElement('img');
      img.src = 'https://mail.google.com/mail/?logout&hl=en';
      img.style.display = 'none';
      document.body.appendChild(img);
      const logoutWindow = window.open('https://mail.google.com/mail/?logout&hl=en', 'Disconnect from Google', 'width=100,height=50,menubar=no,status=no,location=no,toolbar=no,scrollbars=no,top=200,left=200');
      setTimeout(() => {
        if (logoutWindow && !logoutWindow.closed) {
          logoutWindow.close();
        }
        console.log(window.location.origin);
        window.location.href = window.location.origin + '/logout.html';
        this.isLoaded = true;
        this.logOut = true;
      }, 1500);


      this.isLoaded = true;
      this.logOut = true;
      localStorage.setItem('sign_out_msg', this.$t('logout-msg'));
      localStorage.setItem('sign_in', this.$t('login'));
    },
    closeError(id) {
      this.errMsgs = this.errMsgs.filter(obj => obj.id != id);
    },
    closeAlert(id) {
      this.alerts = this.alerts.filter(obj => obj.id != id);
    },

    selectTab(id, tabId) {
      this.selectedTabHref = id;
      if (tabId) {
        this.selectTabId = tabId;
        this.activeTab = tabId;
      }
    },
    formatDate(dateString, format, remarks) {
      if (dateString) {
        const date = new Date(dateString);
        const day = date.getUTCDate().toString().padStart(2, '0');
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        const year = date.getUTCFullYear();

        return format ? `${month}-${day}-${year}` : remarks ? `${day}-${month}-${year}` : `${year}-${month}-${day}`;
      } else {
        return null;
      }
    },
    async getTrainingAgeTable() {
      try {
        let res = await fetch(
          this.storageBaseUrl + '/static/assets/training-age.tsv',
        );
        let maleWeights;
        let femaleWeights;

        let data = await res.text();
        const lines = data.split('\n');
        lines.forEach((line) => {
          const columns = line.split('\t');
          if (columns[0] == 'Male') {
            maleWeights = columns.slice(2);
            maleWeights[maleWeights.length - 1] = maleWeights[maleWeights.length - 1].replace(
              '\r',
              '',
            );
          }
          if (columns[0] == 'Female') {
            femaleWeights = columns.slice(2);
            femaleWeights[maleWeights.length - 1] = femaleWeights[femaleWeights.length - 1].replace(
              '\r',
              '',
            );
          }

          if (columns[0].includes('Male-')) {
            this.trainingAgeTable.male[columns[0].slice(5)] = {};
            columns.slice(2).forEach((weights, index) => {
              this.trainingAgeTable.male[columns[0].slice(5)][maleWeights[index]] = weights.replace('\r', '').replace(',', '.');
            });
          }

          if (columns[0].includes('Female-')) {
            this.trainingAgeTable.female[columns[0].slice(7)] = {};
            columns.slice(2).forEach((weights, index) => {
              this.trainingAgeTable.female[columns[0].slice(7)][femaleWeights[index]] = weights.replace('\r', '').replace(',', '.');
            });
          }

          if (columns[0].includes(' Duration')) {
            this.durationTable.push({
              from: columns[1],
              to: columns[2],
              value: columns[3]
            });
          }
          if (columns[0].includes('QS') && !columns[0].includes('type-')) {
            this.qsTable.push({
              from: columns[1],
              to: columns[2],
              value: columns[3]
            });
          }

          if (columns[0].includes('weighted-')) {
            this.weightedTable[columns[1]] = columns[2];
          }
          if (columns[0].includes('type-')) {
            this.QSType = columns[1];
          }
          if (columns[0] == "sessions-used") {
            this.sessionsUsed = columns[1];
          }
          if (columns[0] == "max-increase") {
            this.maxIncrease = columns[1];
          }
          if (columns[0] == "max-decrease") {
            this.maxDecrease = columns[1];
          }
          if (columns[0] == "min-age-exercise") {
            this.minAgeExercise = columns[1];
          }
          if (columns[0] == "min-sessions-needed") {
            this.minSessionsNeeded = columns[1];
          }
        });
      } catch (err) {
        console.log({
          err
        });
        this.errors.push("Error in load training age in app.js " + formattedDateTime());
        this.errors.push(err + " " + formattedDateTime());
        window.alert(this.$t('load-ta-err'));
      }
    },
    async callback() {
      // fit20.app.access_token = res.code;
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');

      if (code) {
        try {
          // localStorage.setItem('user-email', "test");
          const url =
            this.baseUrl + '/api/auth/accessToken?code=' + code + `&baseURL=${this.baseUrl.replace(/^https?:\/\//, '')}`;
          const result = await fetch(url);
          const results = await result.json();
          if (results.msg) {
            console.error(results.err);
            this.clearLocalStorage();
            this.isLoaded = true;
            alert(this.$t('authentication-error'));
          } else {
            const base64Url = results.id_token.split('.')[1];

            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            const decodedToken = JSON.parse(jsonPayload);
            localStorage.setItem('user-email', decodedToken.email);
            localStorage.setItem('access_token', results.access_token);
            localStorage.setItem('refresh_token', results.refresh_token);
            localStorage.setItem('last_token_time', new Date().getTime());
            // to do set a auth token 
          }
        } catch (err) {
          this.clearLocalStorage();
          this.isLoaded = true;
          window.alert(this.$t('authentication-error'));
        }

      }
      try {
        const userEmail = localStorage.getItem('user-email');
        if (userEmail && !this.user.id) {
          let user = await fetch(this.baseUrl + "/api/users/user?email=" + userEmail + "&accessToken=" + localStorage.getItem('access_token') + "&user=" + userEmail);
          let result = await user.json();
          if (result.msg) {
            this.clearLocalStorage();
            this.logOut = true;
            // window.location.href = window.location.href;
            // window.alert('sign-out-msg');
            // alert(this.$t(result.msg));
          } else {
            this.user = result;
          }
          if (this.user && this.user.active) {
            if (this.user.role == 'admin') {
              let getStudios = await fetch(this.baseUrl + "/api/studios?accessToken=" + localStorage.getItem('access_token') + "&user=" + userEmail);
              let result = await getStudios.json();
              if (result.msg) {
                this.clearLocalStorage();
                alert(this.$t(result.msg));
              } else {
                this.studios = result;
              }
            } else {
              this.adminApp = false;
              // get only user studio
              let getStudios = await fetch(this.baseUrl + "/api/studios/trainer/" + this.user.id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + userEmail);
              let result = await getStudios.json();
              if (result.msg) {
                this.clearLocalStorage();
                alert(this.$t(result.msg));
              } else {
                this.studios = result;
              }
            }
            this.isLoaded = true;
          } else {
            // throw permission denied
            this.isLoaded = true;
            // window.alert(this.$t('inactive-user'));
            this.clearLocalStorage();
            window.location.href = window.location.origin;
          }
        }
      } catch (err) {
        console.log(err);
        this.clearLocalStorage();
        this.isLoaded = true;
        alert(this.$t('authentication-error'));
      }
    },
  },
  async created() {
    this.getBrowserInfo();
    this.errors.push("Browser : " + this.getBrowserInfo() + " " + formattedDateTime());
    if (window.length.pathname == "/logout") {
      this.logOut = true;
    }
    const vm = this;
    if (window.location.host.includes("localhostxxx") || window.location.host.includes('192.168.1')) {

      let user = await fetch(this.baseUrl + "/api/users/user?email=mohammaddarwesh@fit20.com"); // change the email to it email
      this.user = await user.json();
      if (this.user.active) {
        if (this.user.role == 'admin') {
          let getStudios = await fetch(this.baseUrl + "/api/studios?access_token=");
          this.studios = await getStudios.json();
        } else {
          this.adminApp = false;
          // get only user studio
          try {
            let getStudios = await fetch(this.baseUrl + "/api/studios/trainer/" + this.user.id);
            this.studios = await getStudios.json();
            if (this.studios.msg && this.studios.msg == 'no active Studios found') {
              this.studios = [];
              this.errMsgs.push({
                id: Date.now(),
                type: 'msg',
                msg: this.$t('no-studios-found')
              });
            } else if (this.studios.msg) {
              this.errMsgs.push({
                id: Date.now(),
                type: 'msg',
                msg: 'Server error!'
              });
            }
          } catch (err) {
            this.errMsgs.push({
              id: Date.now(),
              type: 'err',
              msg: 'Server error!'
            });
          }

        }
        if (window.location.pathname == "/admin" || window.location.pathname == "/admin/") {
          // window.brands.forEach(brand => {
          //   this.brands.push(this.$t(brand));
          // });
          this.adminApp = true;
        }

        // this.languages = window.languages;
        let langCode = this.user.language ? this.user.language : 'en';
        i18n.setLocaleMessage(langCode, messages[langCode]);
        this.$i18n.locale = langCode;

        try {
          let getMachines = await fetch(this.baseUrl + "/api/machines");
          this.machines = await getMachines.json();
        } catch (err) {
          console.error(err);
          this.errors.push('Error with getting machines in app.js ' + formattedDateTime());
          this.errors.push(err.message + " " + formattedDateTime());
          window.alert('Server Error!');
        }
        this.isLoaded = true;
      } else {
        window.alert(this.$t('unknown-user'));
      }
    } else {

      if (!window.location.host.includes("localhost")) {
        this.baseUrl = window.location.protocol + '//' + window.location.host;
      }
      try {
        // To do: make the the client_id dynamic 
        let client_id = window.location.host.includes("localhost") || window.location.host.includes('192.168.1') || window.location.host.includes('test.') ? '103079258064-7qgliijq6gr03r6jhq87on3vhnq5uaep.apps.googleusercontent.com' : '456985267766-vij4mo8uqfjp2fum8vmm19ud6rcf24dg.apps.googleusercontent.com';
        // code model
        let redirect_uri = !this.adminApp ? window.location.protocol + '//' + window.location.host : window.location.protocol + '//' + window.location.host + '/admin';
        let client = window.google.accounts.oauth2.initCodeClient({
          client_id: client_id,
          scope: 'profile email https://www.googleapis.com/auth/drive.readonly',
          ux_mode: 'redirect',
          redirect_uri: redirect_uri,
          access_type: 'offline',
          prompt: 'login'
        });
        await this.callback();
        if (window.location.search != '') {
          const newUrl = window.location.origin + window.location.pathname;
          window.history.replaceState({}, document.title, newUrl);
        }
        const token = localStorage.getItem('user-email');
        if (!token) {
          client.requestCode();
        } else {
          this.getRefreshToken();
        }

        if (this.user.id) {
          await this.getTranslation();
          if (this.hostProtocol.includes('s')) {
            this.MSA_port = '1063';
          }
          if (window.location.pathname == "/admin" || window.location.pathname == "/admin/") {
            // window.brands.forEach(brand => {
            //   this.brands.push(this.$t(brand));
            // });
            this.adminApp = true;
          }
          ///////////////// code to add sessions for test server only////////////////////
          // let date = new Date("2024-09-11T10:13:09.551Z");
          // for (let i = 1; i <= 20; i++) {
          //   let newSession = { "date": date, "number": i, "partners": [], "exercises": [{ "remark": "", "machineId": "3001", "order": 1, "weight": "22.5", "duration": 102, "weightChange": "", "qs_average": 0, "qs_range": 0, "qs_rhythm": 0, "qs_tempo": 0 }, { "remark": "", "machineId": "5001", "order": 2, "weight": "32.5", "duration": 97, "weightChange": "", "qs_average": 0, "qs_range": 0, "qs_rhythm": 0, "qs_tempo": 0 }, { "remark": "", "machineId": "4002", "order": 3, "weight": 15, "duration": 99, "weightChange": "", "qs_average": 0, "qs_range": 0, "qs_rhythm": 0, "qs_tempo": 0 }, { "remark": "", "machineId": "1001", "order": 4, "weight": "77.6", "duration": 112, "weightChange": "", "qs_average": 0, "qs_range": 0, "qs_rhythm": 0, "qs_tempo": 0 }, { "remark": "", "machineId": "4001", "order": 5, "weight": 5, "duration": 108, "weightChange": "", "qs_average": 0, "qs_range": 0, "qs_rhythm": 0, "qs_tempo": 0 }, { "remark": "", "machineId": "1002", "order": 6, "weight": "12.5", "duration": 86, "weightChange": "SAME", "qs_average": 0, "qs_range": 0, "qs_rhythm": 0, "qs_tempo": 0 }], "studio": "6066595164061696", "trainer": { "id": "1012049", "initials": "RRE" }, "absent": false, "absentReason": "", "remark": "", "lastModified": [], "training_age": { "overall_qs": "", "age_group_level": "", "best_contributor": "", "control_age": "", "coordination_age": "", "train_at_level": "", "younger_since_start": "" }, "id": false, member: "4583542865526784" };

          //   date.setDate(date.getDate() + 7);
          //   let session = JSON.parse(JSON.stringify(newSession));
          //   let updateSession = await fetch(this.baseUrl + "/api/sessions/" + this.user.email + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.user.email, {
          //     method: 'POST',
          //     headers: {
          //       'Content-Type': 'application/json'
          //     },
          //     body: JSON.stringify(session),
          //   });
          // }
          ///////////////// End the code to add sessions ////////////////////
          this.getTrainingAgeTable();

          try {
            // Fetch the image
            const defaultMemberImg = await fetch(this.storageBaseUrl + '/member/default.svg');
            // Convert the response to a Blob
            const blob = await defaultMemberImg.blob();
            // Convert the Blob to a base64 string
            this.defaultMemberImg = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            });

            // Fetch the image
            const defaultStudioImg = await fetch(this.storageBaseUrl + '/studio/default.svg');
            // Convert the response to a Blob
            const blob2 = await defaultStudioImg.blob();
            // Convert the Blob to a base64 string
            this.defaultStudioImg = await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob2);
            });
          } catch (err) {
            console.log({
              err
            });
            this.errors.push("Error in load default images in app.js " + formattedDateTime());
            this.errors.push(err + " " + formattedDateTime());
          }
          // check if there is an active session before reload.
          window.addEventListener('beforeunload', function (e) {
            let activeSession;
            Object.keys(vm.tabs).forEach(tab => {
              if (vm.tabs[tab]['active']) {
                activeSession = true;
              }
            })
            if (activeSession) {
              e.preventDefault();
              const confirmationMessage = 'Are you sure you want to leave?';
              return confirmationMessage;
            }
          });
          try {
            let getMachines = await fetch(this.baseUrl + "/api/machines" + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.user.email);
            let result = await getMachines.json();

            if (result.msg) {
              this.clearLocalStorage();
              alert(this.$t(result.msg));
            } else {
              this.machines = result;
            }

            function inactivityTime() {
              var time;
              // events

              let resetTime;
              resetTime = () => {
                let user = localStorage.getItem('user-email');
                let accessToken = localStorage.getItem('access_token');
                let refreshToken = localStorage.getItem('refresh_token');
                if (!user && !accessToken && !refreshToken) {
                  resetTime = null;
                  vm.clearLocalStorage();
                  vm.logOut = true;
                }

                let checkTime = localStorage.getItem('check_time');
                let lastAccessToken = localStorage.getItem('last_token_time');
                if (!checkTime) {
                  localStorage.setItem('check_time', new Date().getTime());
                }
                // force to logout if the user inactive for more than 58 min
                else if ((new Date().getTime() - checkTime) > (60 * 60 * 1000)) {
                  vm.signOut();
                }
                else if (checkTime - lastAccessToken > (55 * 60 * 1000)) {
                  vm.getRefreshToken();
                  vm.errors.push('Get refresh token ' + formattedDateTime());
                  localStorage.setItem('check_time', new Date().getTime());
                }
                else {
                  localStorage.setItem('check_time', new Date().getTime());
                }
                clearTimeout(time);
                time = setTimeout(vm.signOut, 58 * 60 * 1000);
              }
              window.onfocus = resetTime;
              window.onload = resetTime;
              window.onclick = resetTime;
              // window.onkeypress = resetTime;
              window.ontouchstart = resetTime;
              window.onmousemove = resetTime;
              window.onmousedown = resetTime;
              window.ontouchstart = resetTime;
              window.ontouchmove = resetTime;
              window.ontouchend = resetTime;
              window.addEventListener('scroll', resetTime, true);
              document.addEventListener("visibilitychange", function () {
                if (!document.hidden) {
                  if (resetTime) {
                    resetTime(); // User returned
                  }

                }
              });
              resetTime();
            };
            inactivityTime();
            // ask for refresh token every hour

            setInterval(this.getRefreshToken, 58 * 58 * 1000);
          } catch (err) {
            console.error(err);
            this.errors.push('Error with getting machines in app.js ' + formattedDateTime());
            this.errors.push(err.message + " " + formattedDateTime());
            window.alert('Server Error!');

          }
        }
      } catch (err) {
        this.clearLocalStorage();
        console.log(err);
        this.errors.push('Authentication in app.js ' + formattedDateTime());
        this.errors.push(err.message + " " + formattedDateTime());
        window.alert('Authentication Error!');
      }
    }
  },
};
</script>

<style>
:root {
  --fit20-green: #92d400;
  --fit20-gray: #616365;
  --fit20-light-gray: #22222280;
  --fit20-lighter-gray: #0000002f;
  --fit20-blue: #009EFB;
  --fit20-light-blue: #009FE380;
  --fit20-lighter-blue: #DDF3FB;
  ;
  --fit20-pink: #e5007d;
  --fit20-orang: #FC802D;

}

.green {
  color: var(--fit20-green);
}

.orange {
  color: var(--fit20-orang);
}

.pink {
  color: var(--fit20-pink);
}

/* .popup-overlay>div {
  border: solid 3px var(--fit20-green);
  border-radius: 10px;
} */

@font-face {
  font-family: 'VAG light';
  src: url('./assets/fonts/rond-light.woff2') format('woff2');
  font-display: swap;
}

/* @font-face {
  font-family: 'open sans';
  src: url('./assets/fonts/opensans.woff2') format('woff2');
  font-display: swap;
} */
@font-face {
  font-family: 'open sans';
  src: url('./assets/fonts/OpenSans-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.vag-light {
  font-family: 'VAG light', 'Courier New', Courier, monospace;
}

html,
body {
  width: 100%;
  /* overflow-x: hidden; */
  scroll-behavior: smooth;
  overflow: hidden;
  font-family: 'VAG light', 'Courier New', Courier, monospace;
}

body {
  min-width: 400px;
  margin: 0 auto;
  animation: appear-main 1s;
}

.text-primary {
  color: var(--fit20-green);
}

.text-secondary {
  color: var(--fit20-blue);
}

.text-body {
  color: var(--fit20-gray);
}

.studios {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-height: calc(100% - 200px);
  /* Adjust as needed */
  overflow: auto;
}

.studio-card {
  margin: 5px;
  border: solid 1px var(--fit20-lighter-gray);
  width: calc(100% / 3 - 10px);
  height: 85px;
  border-radius: 10px;

  /* dding-left: 5px;pa */
}

.studio-card a {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  color: var(--fit20-blue) !important;
}

.card-div {
  height: 100%;
  padding: 6px;
}

.card-div img {
  width: 35%;
  /* padding: 8px; */
  border-radius: 10px;
  max-height: 70px;
  max-width: 70px;

}

.item-name {
  margin-top: 3px;
  margin-left: 5px;
  width: 60%;
  word-break: break-word;
}

.pointer {
  cursor: pointer;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.active {
  display: block !important;
}

.show {
  opacity: 1 !important;
}

.fade {
  opacity: 0;
}

.display-none {
  display: none;
}

.form-container input,
.form-container select,
.form-container textarea {
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 5px;
  padding: 3px 5px;
  width: 95%;
  background-color: white;
  color: var(--fit20-gray);
}

.field-sec label {
  padding: 10px 0;
  color: var(--fit20-gray);
}

.inputFileHidden {
  position: relative;
  overflow: hidden;
}

.inputFileHidden input[type='file'] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 50px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.doc-content {
  margin: 0 auto;
}

span.img-container {
  display: inline-block;
  position: relative;
}

.img-ico {
  position: absolute;
  bottom: 15px;
  right: 5px;
  width: 40px;
}

.btn-container {
  text-align: right;
  margin-top: 10px;
  margin-right: 15px;
}

.fit20-btn {
  padding: 1px 15px;
  border-radius: 5px;
  cursor: pointer;
}

.save-btn-active {
  color: white !important;
  background-color: var(--fit20-blue) !important;
  transition: all 1s;
  margin-left: 10px;
}

.cancel-btn-active {
  color: white !important;
  background-color: var(--fit20-blue) !important;
  transition: all 1s;
}

.save-btn-disable {
  color: var(--fit20-blue);
  border: solid 1px var(--fit20-blue);
  transition: all 1s;
  margin-left: 10px;
}

.cancel-btn-disable {
  color: var(--fit20-blue);
  border: solid 1px var(--fit20-blue);

  transition: all 1s;
}

.dropdown-container {
  position: relative;
  display: block;
  background-color: white;
  z-index: 999999999999999999;
}

.dropdown-options {
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  max-height: 130px;
  overflow-y: auto;
  border-radius: 5px;
  width: -moz-available;
  text-align: center;
}

.dropdown-option {
  padding: 8px;
  cursor: pointer;
  border-radius: 5px;
}

.dropdown-option:hover {
  background-color: #e0e0e2;
}

.switch-btn {
  display: flex;
  justify-content: space-between;
  align-items: end;
}

.custom-select {
  position: relative;
  display: inline-block;
}

.custom-select select {
  display: none;
}

.select-selected {
  background-color: #f1f1f1;
  padding: 5px 10px;
  border: 1px solid #ccc;
  cursor: pointer;
}

.select-items div:hover,
.same-as-selected {
  background-color: #ddd;
}

.select-items {
  position: absolute;
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
  z-index: 999;
}

.popup-content {
  background-color: white;
  width: 85%;
  padding: 0px 0px 20px 0px;
  border-radius: 10px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
}

.popup-title {
  background-color: var(--fit20-green);
  color: white;
  justify-content: space-between;
  padding: 10px 15px;
  /* border-top-right-radius: 10px;
  border-top-left-radius: 10px; */
}

@keyframes appear-main {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

ul {
  list-style: none;
}

a:focus,
a:visited,
a:link,
a:hover {
  text-decoration: none;
}

.animated {
  border-radius: 10px;
  -webkit-animation-duration: .7s;
  animation-duration: .7s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated:not(.not) {
  border: solid 3px var(--fit20-green);
}

.animated2 {
  border: solid 3px var(--fit20-green);
  border-radius: 10px;
  -webkit-animation-duration: .4s;
  animation-duration: .4s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

.zoomIn {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
}

@-webkit-keyframes zoomOut {
  from {
    opacity: 1;
  }

  50% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
}

@keyframes zoomOut {
  from {
    opacity: 1;
  }

  50% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
}

.zoomOut {
  -webkit-animation-name: zoomOut;
  animation-name: zoomOut;
}

.date {
  position: relative;
}

.date-picker {
  position: absolute !important;
  top: 0;
  background-color: transparent;
  width: 100%;
}

.date-picker input {
  background-color: transparent !important;
  width: 90%;
  border: none !important;
}

@media only screen and (min-width: 770px) {}
</style>
